import { mapGetters } from "vuex";
import { PERMISSIONS } from "@/constants/roles";
import { FEATURE } from "@/constants/entitlements";

// สิทธิ์จัดการ "แบบฟอร์มคลินิก" (mediaFile category "Template") — เพิ่ม/ลบได้เฉพาะ
// ผู้จัดการสาขา (MANAGER) และผู้บริหารระดับคลินิก (RDM / C_LEVEL)
//
// ใช้ can() ไม่ใช่ getIsAccessMenu(): getIsAccessMenu รู้จักแค่ branch role id 1-7
// จึงตัด RDM (101) / C_LEVEL (102) ทิ้งทุกกรณี
//
// can() คืน false ระหว่าง permissionContext ยังโหลดไม่เสร็จ — ปุ่มจะโผล่ช้าเสี้ยว
// วินาทีหลังเข้าหน้า ซึ่งเป็น tradeoff เดียวกับ Sidebar/BranchMembers ที่ใช้อยู่แล้ว
// (router ยิง ensureClinicPermissionContext ให้ทุกหน้าที่มี param clinicUrl)
//
// อัปโหลดแบบฟอร์มใหม่ต้องมีแพ็กที่จ่ายเงิน (BASIC / PRO / PREMIUM) ด้วย — ใช้ธง
// DOCUMENT_GENERATOR ที่แพ็กเหล่านี้เปิดและ FREE ปิด แทนการเทียบชื่อแพ็ก เพื่อให้
// ตามสิทธิ์จริงจาก entitlements (รวมแพ็กเดิม/เส้นทางถอยตอนยังโหลดไม่เสร็จ) ลบและเซ็น
// แบบฟอร์มที่มีอยู่แล้วไม่ติดแพ็ก
export default {
  computed: {
    ...mapGetters({
      canGetter: "moduleUser/can",
      branchInfoForClinicForm: "moduleUser/getBranchInfo",
      entitlementFlagForClinicForm: "moduleBranch/entitlementFlag",
    }),
    canManageClinicForm() {
      return this.canGetter(PERMISSIONS.MEDIAFILE_TEMPLATE_MANAGE, {
        clinicId: this.branchInfoForClinicForm?.clinic?.id,
        branchId: this.branchInfoForClinicForm?.id,
      });
    },
    hasClinicFormPlan() {
      return this.entitlementFlagForClinicForm(FEATURE.DOCUMENT_GENERATOR);
    },
    canUploadClinicForm() {
      return this.canManageClinicForm && this.hasClinicFormPlan;
    },
  },
};
